import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import Collapsible from 'Components/Collapsible'
import Rooms from 'Components/Rooms'
import { Description } from '../Description'
import { ListingFeatures } from '../ListingFeatures'


const ListingDetails = ({
  googleAnalyticsEvent, listing, listingInfoHidden, listingPhotoHidden, listingIsLocked, openHouses, actualSize,
  unitSystemIsImperial, isCondo, mobileBrowser, rooms, requiredEmailVerification, openLogin, sizeMin, sizeMax,
  sizeLabel, openEmailVerifyModal, toggleMetric, listingIsLockedRoomOrFeatures, isMobileApp, collapsibleIdSuffix,
}) => {
  const { title, name } = listing || {}

  return (
    <Collapsible
      inputId={`Listing_Details-${collapsibleIdSuffix}`}
      title={'Listing Details'}
      gaActionTitle={'Listing Details'}
      seoText={
        `Learn about ${title || name || ''}`
      }
      defaultShowState
    >
      <Description
        listing={listing}
        listingInfoHidden={listingInfoHidden}
        listingPhotoHidden={listingPhotoHidden}
        listingIsLocked={listingIsLocked}
        googleAnalyticsEvent={googleAnalyticsEvent}
        isMobileApp={isMobileApp}
        openHouses={openHouses}
      />
      {
        !listingInfoHidden && (
          <Fragment>
            <ListingFeatures
              listing={listing}
              unitSystemIsImperial={unitSystemIsImperial}
              isCondo={isCondo}
              sizeMin={sizeMin}
              sizeMax={sizeMax}
              actualSize={actualSize}
              sizeLabel={sizeLabel}
              mobileBrowser={mobileBrowser}
              googleAnalyticsEvent={googleAnalyticsEvent}
              isLocked={listingIsLockedRoomOrFeatures}
              isMobileApp={isMobileApp}
            />
            <Rooms
              rooms={rooms}
              listingIsLocked={listingIsLockedRoomOrFeatures}
              toggleMetric={toggleMetric}
              unitSystemIsImperial={unitSystemIsImperial}
              isCondo={isCondo}
              openLogin={openLogin}
              requiredEmailVerification={requiredEmailVerification}
              openEmailVerifyModal={openEmailVerifyModal}
            />
          </Fragment>
        )
      }
    </Collapsible>
  )
}


ListingDetails.propTypes = {
  listing: PropTypes.shape({
    id: PropTypes.number,
    title: PropTypes.string,
    lowest_area: PropTypes.shape({}),
  }),
  googleAnalyticsEvent: PropTypes.func,
  listingInfoHidden: PropTypes.bool,
  listingPhotoHidden: PropTypes.bool,
  listingIsLocked: PropTypes.bool,
  listingIsLockedRoomOrFeatures: PropTypes.bool,
  unitSystemIsImperial: PropTypes.bool,
  mobileBrowser: PropTypes.bool,
  isCondo: PropTypes.bool,
  sizeMin: PropTypes.number,
  sizeMax: PropTypes.number,
  sizeLabel: PropTypes.string,
  rooms: PropTypes.arrayOf(PropTypes.shape({})),
  toggleMetric: PropTypes.func,
  openLogin: PropTypes.func,
  requiredEmailVerification: PropTypes.bool,
  openEmailVerifyModal: PropTypes.func,
  isMobileApp: PropTypes.bool,
  collapsibleIdSuffix: PropTypes.string,
  openHouses: PropTypes.arrayOf(PropTypes.shape({})),
  actualSize: PropTypes.number,
}

export default ListingDetails
